<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">CONFIRM To Cancel Transaction</div>
        <div>
          <bread-crumb :bread-crumbs="['Cancel Transaction']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card class="mx-auto" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <v-col class="text-overline mb-4 border primary">
              <v-row justify="space-between" class="p-4">
                <div>
                  <b>PIN NO :</b>
                  {{ transactionInfo && transactionInfo.pin_umber }}
                </div>
                <div><b>TRANS ID :</b> {{ transactionInfo.txn_id }}</div>
                <div><b>Generated :</b> 2023-10-16 01:44:55 PM : Liyana</div>
                <div><b>Approved : </b>2023-10-16 01:44:55 PM : Liyana</div>
              </v-row>
            </v-col>
            <div class="mb-10">
              <v-row justify="space-between">
                <v-col cols="12" lg="12" xs="12">
                  <v-row justify="space-between">
                    <v-col cols="12" lg="4" xs="12">
                      <div class="menu-sec">
                        <v-list-item>Sender Information</v-list-item>
                        <v-list-item class="text-primary"
                          ><b>{{
                            senderInfo.middle_name
                              ? senderInfo.first_name +
                                " " +
                                senderInfo.middle_name +
                                " " +
                                senderInfo.last_name
                              : senderInfo.last_name
                              ? senderInfo.first_name +
                                " " +
                                senderInfo.last_name
                              : senderInfo.first_name
                          }}</b></v-list-item
                        >
                        <v-list-item
                          >{{
                            senderInfo.nationality &&
                            senderInfo.nationality.name
                          }}
                          , {{ senderInfo.address }}</v-list-item
                        >
                        <v-list-item
                          >Company Name:
                          <b>{{ senderInfo.bank }}</b></v-list-item
                        >
                        <v-list-item
                          >Phone: {{ senderInfo.mobile }}</v-list-item
                        >
                        <v-list-item
                          >Passport: {{ senderInfo.passport }}</v-list-item
                        >
                        <v-list-item
                          >Native Country:
                          <b>{{ senderInfo.nationality.name }}</b></v-list-item
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4" xs="12">
                      <div class="menu-sec">
                        <div>Receiver Information</div>
                        <div class="text-primary">
                          <b>{{ this.receiver_fullname }}</b>
                        </div>
                        <div>
                          {{ recieverInfo.address }} ,
                          {{ recieverInfo.address }}
                        </div>
                        <div>
                          Company Name: <b>{{ recieverInfo.location_name }}</b>
                        </div>
                        <div>Phone: {{ recieverInfo.mobile }}</div>
                        <div>Passport: {{ recieverInfo.passport }}</div>
                        <div>
                          Native Country: <b>{{ recieverInfo.address }}</b>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4" xs="12">
                      <div class="menu-sec">
                        <div>QQ Pay Sdn Bhd (44609-M)</div>
                        <div>MALAYSIA</div>
                        <div>
                          Transaction Mode:
                          <b>{{ transactionInfo.payment_mode }}</b>
                        </div>
                        <div class="mt-2">
                          Status:
                          <v-chip
                            rounded
                            small
                            :color="getColor(transactionInfo.txn_status)"
                            block
                            outlined
                          >
                            {{ transactionInfo.txn_status }}
                          </v-chip>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <v-col class="p-2 ms-3">
              <v-row justify="space-between">
                <v-col cols="12" lg="8" xs="12" class="border py-8">
                  <v-form ref="Addform" v-model="valid">
                    <v-row justify="center" class="ms-1 me-1">
                      <v-col cols="12" md="4">
                        <label class="required">Reason</label>
                        <v-autocomplete
                          outlined
                          dense
                          class="rounded"
                          placeholder="Select Value"
                          item-text="value"
                          item-value="value"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4">
                        <label class="required">Refund</label>
                        <v-autocomplete
                          outlined
                          dense
                          class="rounded"
                          placeholder="Refund"
                          item-text="value"
                          item-value="value"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4">
                        <label class="required">Cancel Date</label>
                        <v-checkbox outlined dense label="Edit"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <v-col cols="12" lg="4" xs="12">
                  <v-row justify="" class="p-4">
                    <div class="menu-sec">
                      <v-list-item
                        >Collected Amount :
                        <b>{{ transactionInfo.total_coll_amt }}</b></v-list-item
                      >
                      <v-list-item
                        >Transfer Amount :
                        <b>{{ transactionInfo.transfer_amt }}</b></v-list-item
                      >
                      <v-list-item
                        >Payout Amount :
                        <b>{{ transactionInfo.payout_amt }}</b></v-list-item
                      >
                      <v-list-item
                        >Service Charge :
                        <b>{{ transactionInfo.service_charge }}</b></v-list-item
                      >
                      <v-list-item
                        >Customer Rate : 1 MYR = 1.635 HKD</v-list-item
                      >
                      <v-list-item
                        >Settlement Rate : 1 MYR = 1.64 HKD</v-list-item
                      >
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions class="ms-3">
          <!-- <v-spacer></v-spacer> -->
          <v-btn outlined text
            ><v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
            Cancel Now
          </v-btn>
          <v-btn outlined text>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              x </v-icon
            >Don't Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </section>
</template>

<script>
import PaymentService from "@/services/PaymentService/paymentService.js";
export default {
  name: "Cancel Transaction",
  data: () => {
    return {
      transactionDetails: {},
      transactionInfo: null,
      senderInfo: null,
      recieverInfo: null,
      sender_fullname: "",
      receiver_fullname: "",
    };
  },
  components: {
    // listOverviewVue
  },
  computed: {},
  watch: {},
  mounted() {
    if (this.$route.query.id) {
      this.getTxnDetailsbyID();
    }
  },
  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },

    getColor(status) {
      if (status === "Pending") {
        return "orange";
      } else if (status === "Hold") {
        return "red";
      } else if (status === "Paid") {
        return "success";
      }
    },

    async getTxnDetailsbyID() {
      this.loader = true;
      try {
        const responseData = await PaymentService.getTxnDetails(
          this.$route.query.id
        );
        if (responseData && responseData.data.status_code === 200) {
          console.log(responseData.data);
          this.transactionDetails = { ...responseData.data.data[0] };
          this.transactionInfo = this.transactionDetails.txn_data;
          this.senderInfo = this.transactionDetails.sender_data;
          this.recieverInfo = this.transactionDetails.receiver_data;
          this.sender_fullname =
            this.senderInfo.first_name +
            " " +
            this.senderInfo.middle_name +
            " " +
            this.senderInfo.last_name;
          this.receiver_fullname = this.recieverInfo.full_name;

          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
          this.loader = false;
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

.menu-sec {
  margin-top: 20px;
  div {
    min-height: 22px;
  }
}
.text-overline {
  color: white;
}

tr:nth-child(even) {
  background-color: #eee;
}
tr:hover {
  background: none !important;
}
th {
  text-transform: uppercase;
}
</style>
